<template>
    <div class="main partner">
        <div class="head">
            <span style="margin-bottom:.3rem">智慧伊旗农牧大数据平台</span>
            <div class="gobcak" @click="goBack"><img src="../../assets/return.png" alt=""><span>返回上一层</span>
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div class="server">
                    <span class="card"></span>
                    <span class="text">企业基本信息</span>
                </div>
                <div class="top">
                    <h1>东方迈德科技有限公司</h1>
                    <div class="phone-type">
                        <div class="phone">
                            <span>联系电话：</span>
                            <span>185****9870</span>
                        </div>
                        <div class="type">
                            <span>种养殖类型：</span>
                            <span>活畜</span>
                        </div>
                    </div>
                    <div class="phone-type">
                        <span>所在区域：</span>
                        <span>内蒙古-鄂尔多斯-伊金霍洛旗</span>
                    </div>
                    <div class="server-b" style="margin-top: .48rem;">
                        <div style="display: flex;align-items: center;">
                            <span class="card-1-b" style="padding: 0px;">设备统计</span>
                        </div>
                    </div>
                    <div class="photo-box">
                        <div class="num-box">
                            <div class="num">666</div>
                            <div class="txt">耳标数</div>
                        </div>
                        <div class="num-box" style="margin-left: 1.66rem;">
                            <div class="num">666</div>
                            <div class="txt">网关数</div>
                        </div>
                        <div class="num-box" style="margin-left: 1.65rem;">
                            <div class="num">666</div>
                            <div class="txt">摄像头数</div>
                        </div>
                    </div>
                </div>
                <div class="center">
                    <div class="hot">
                        <div class="hot-box">
                            <div class="l-box">
                                <img src="../../assets/yq/hot.png" alt="">
                                <div class="text">
                                    <span>耳标测温：活畜体温过高</span>
                                    <span>2023-04-06 14:30:12</span>
                                </div>
                            </div>
                            <div class="look">查看</div>
                        </div>
                        <div class="hot-box">
                            <div class="l-box">
                                <img src="../../assets/yq/hot.png" alt="">
                                <div class="text">
                                    <span>耳标测温：活畜体温过高</span>
                                    <span>2023-04-06 14:30:12</span>
                                </div>
                            </div>
                            <div class="look">查看</div>
                        </div>
                        <div class="hot-box">
                            <div class="l-box">
                                <img src="../../assets/yq/hot.png" alt="">
                                <div class="text">
                                    <span>耳标测温：活畜体温过高</span>
                                    <span>2023-04-06 14:30:12</span>
                                </div>
                            </div>
                            <div class="look">查看</div>
                        </div>
                    </div>
                </div>
                <div class="top" style="margin-top: 0rem;">
                    <div class="server-b" style="margin-top: 0.36rem;">
                        <div style="display: flex;align-items: center;">
                            <span class="card-1-b" style="padding: 0px;">实时监控</span>
                        </div>
                    </div>
                    <div class="quan">
                        <el-dropdown @command="selectLive" trigger="click">
                            <span style="margin-left: .1rem" class="el-dropdown-link">
                                {{ command }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu style="border: none!important;" slot="dropdown">
                                <template>
                                    <el-dropdown-item v-for="(item, index) in firstList" :key="index" :command='item'>
                                        {{ item }}</el-dropdown-item>
                                </template>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="screenFull" @click="videoShow">
                            <img src="../../assets/screen.png" alt="">
                            <span>全屏</span>
                        </div>
                    </div>
                    <div class="device_main">
                        <div class="video_box">
                            <div class="device_box" ref="device_box">
                                <div id="myPlayer" v-if="(1 == 2)"></div>
                                <video v-else-if="(2 == 3)" autoplay controls width="100%" height="100%" muted
                                    id="myVideo"></video>
                                <div v-else
                                    style="width: 6rem;height: 3.2rem;background-color: #000308;display: flex;justify-content: center;align-items: center;flex-direction: column;">
                                    <img src="../../assets/v_img.png" style="width: 2.29rem;height: 2rem;display: block;"
                                        alt="">
                                    <p
                                        style="font-size: 0.15rem;font-family: Source Han Sans CN-Normal, Source Han Sans CN;font-weight: 350;color: #FFFFFF;margin-top: .25rem;margin-left: .3rem;">
                                        暂无视频</p>
                                </div>
                            </div>
                            <div class="top_box"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right">
                <div class="server-b" style="margin-top: 0px;">
                    <div class="server">
                        <span class="card"></span>
                        <span class="text">活畜信息</span>
                    </div>
                    <div class="date-b">
                        <span @click="cattleStatusBtn('cattle')" :class="{ active: cattleStatus === 'cattle' }">牛</span>
                        <span @click="cattleStatusBtn('sheep')" :class="{ active: cattleStatus === 'sheep' }">羊</span>
                        <span @click="cattleStatusBtn('donkey')" :class="{ active: cattleStatus === 'donkey' }">驴</span>
                    </div>
                </div>
                <div class="num-top num">
                    <div class="number">
                        <div class="hc-num">活畜存栏总数</div>
                        <ul>
                            <li v-for="(item, i) in numberList" :key="i">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div class="number" style="margin-left: 2.4rem;">
                        <div class="hc-num">活畜建档总数</div>
                        <ul>
                            <li v-for="(item, i) in numberList" :key="i">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="num-bottom num">
                    <div class="number" style="margin-top: .38rem;">
                        <div class="hc-num">{{ cattleStatus === 'cattle' ? "牛" : cattleStatus === 'sheep' ? "羊" : "驴"
                        }}只存栏总数</div>
                        <ul>
                            <li style="color: #FFFFFF;" v-for="(item, i) in numberList" :key="i">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div class="number" style="margin-top: .38rem;margin-left: 2.4rem;">
                        <div class="hc-num">{{ cattleStatus === 'cattle' ? "牛" : cattleStatus === 'sheep' ? "羊" : "驴"
                        }}只建档总数</div>
                        <ul>
                            <li style="color: #FFFFFF;" v-for="(item, i) in numberList" :key="i">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="r-c" style="margin-top: .5rem;">
                    <div class="line-bar">
                        <div class="server-b" style="margin-top: 0px;">
                            <div style="display: flex;align-items: center;">
                                <span class="card-1-b">淘汰/产犊数量趋势图</span>
                            </div>
                            <div class="date-b" style="margin-left: .7rem;">
                                <span style="width: auto;" @click="calvingBtn(0)"
                                    :class="{ active: calvingStatus === 0 }">近1月</span>
                                <span style="width: auto;" @click="calvingBtn(1)"
                                    :class="{ active: calvingStatus === 1 }">近3月</span>
                                <span style="width: auto;" @click="calvingBtn(2)"
                                    :class="{ active: calvingStatus === 2 }">近6月</span>
                                <span style="width: auto;" @click="calvingBtn(3)"
                                    :class="{ active: calvingStatus === 3 }">本年度</span>
                            </div>
                        </div>
                        <div id="lineBarChart"></div>
                    </div>
                    <div class="bar commom">
                        <div class="server-b" style="margin-top: 0px;">
                            <div style="display: flex;align-items: center;">
                                <span class="card-1-b">发情/配种</span>
                            </div>
                            <div class="date-b">
                                <span style="width: auto;" @click="breedBtn(0)"
                                    :class="{ active: breedStatus === 0 }">近1月</span>
                                <span style="width: auto;" @click="breedBtn(1)"
                                    :class="{ active: breedStatus === 1 }">近3月</span>
                                <span style="width: auto;" @click="breedBtn(2)"
                                    :class="{ active: breedStatus === 2 }">近6月</span>
                                <span style="width: auto;" @click="breedBtn(3)"
                                    :class="{ active: breedStatus === 3 }">本年度</span>
                            </div>
                        </div>
                        <div id="barChart"></div>
                    </div>
                    <div class="line commom">
                        <div class="server-b" style="margin-top: 0px;">
                            <div style="display: flex;align-items: center;">
                                <span class="card-1-b">产绒量</span>
                            </div>
                            <div class="date-b">
                                <span style="width: auto;" @click="serviceStatusBtn('day')"
                                    :class="{ active: serviceStatus === 'day' }">近7日</span>
                            </div>
                        </div>
                        <div id="lineChart"></div>
                    </div>
                </div>
                <div class="cut">
                    <span @click="Btn(0)" :class="{ activeStatus: btnStatus === 0 }">活畜列表</span>
                    <span @click="Btn(1)" :class="{ activeStatus: btnStatus === 1 }">盘点记录</span>
                </div>
                <div class="table">
                    <div class="search">
                        <el-select @change="changeKindList" v-model="userChange" placeholder="活畜类别"
                            style="margin-right: 0.13rem;font-size:0.13rem">
                            <el-option v-for="item in livestockKindList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="userVariety" placeholder="活畜品种" style="margin-right: 0.13rem;font-size:0.13rem">
                            <el-option v-for="item in liveVarietyList" :key="item.value" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                        <el-select v-if="btnStatus == 0" v-model="userAge" placeholder="月龄"
                            style="margin-right: 0.13rem;font-size:0.13rem">
                            <el-option v-for="item in ageList" :key="item.value" :label="item.label" :value="item.label">
                            </el-option>
                        </el-select>
                        <el-select v-else v-model="userType" placeholder="盘点时间"
                            style="margin-right: 0.13rem;font-size:0.13rem">
                            <el-option v-for="item in userTypeList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input class="search_input" v-model="userName" id="myinput" @focus="focus" @blur="blur"
                            placeholder="输入耳标编号搜索活畜">
                        </el-input>
                        <div class="btn btn_1" @click="getList">搜索</div>
                        <div class="reset_btn btn_1" @click="reset">重置</div>
                        <span class="total">共计<span>10</span>条</span>
                        <div class="left_ l_f" @click="btnClick('left')" :class="{ activeBtn: status === 'left' }">
                            <span class="el-icon-arrow-left"></span>
                        </div>
                        <div class="right_ l_f" @click="btnClick('right')" :class="{ activeBtn: statusRight === 'right' }">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                    <dv-scroll-board ref="setDot" @click="archives" :config="config"
                        style="width:15.6rem;height:4.52rem;margin-top: .25rem;" />
                </div>
            </div>
        </div>
        <netWorkModel ref="netWorkModel"></netWorkModel>
    </div>
</template>
  
<script>
import cityJson from "@/assets/js/city.js";
import netWorkModel from './netWorkModel.vue'
export default {
    components: {
        netWorkModel
    },
    data() {
        return {
            baseArea: cityJson,
            firstList: ['牧场1', '牧场2'],//存储牧场
            command: "我的牧场",
            cattleStatus: "cattle",
            // 产犊数量
            calvingStatus: 0,
            //发情配种
            breedStatus: 0,
            //产绒量
            serviceStatus: 'day',
            btnStatus: 0,
            numberList: [6, 7, 6,],
            // 活畜类别
            livestockKindList: [
                { value: '1', label: '牛' },
                { value: '2', label: '羊' },
            ],
            liveVarietyList: [],
            status: '',
            statusRight: 'right',
            ageList: [
                { value: '0', label: '1-12月' },
                { value: '1', label: '12-24月' },
                { value: '2', label: '24-36月' },
                { value: '3', label: '36-48月' },
                { value: '4', label: '48月以上' }
            ],
            userTypeList: [
                { value: '0', label: '1-12月' },
                { value: '1', label: '12-24月' },
            ],
            userChange: '',
            userVariety: '',
            userAge: '',
            userName: '',
            userType: '',
            //  页码
            pageNum: 1,//第几页
            pageSize: 10,//一页几条
            total: 0,//总数
            config: {},
            lineBarData: [
                {
                    title: '淘汰数量(头)',
                    label: [1, 2, 3, 4, 5, 6, 7],
                    value: [12, 45, 89, 123, 456, 45, 78]
                }, {
                    title: '产犊数量(头)',
                    label: [1, 2, 3, 4, 5, 6, 7],
                    value: [120, 450, 56, 12, 56, 45, 28]
                }
            ],
            breedData: { label: [1, 2, 3, 4, 5, 6, 7], value: [145, 56, 67, 234, 59, 89, 100] },
            day: [{ title: '种公羊', month: [1, 2, 3, 4, 5, 6, 7], value: [150, 230, 224, 218, 135, 147, 260] },
            { title: '母羊', month: [1, 2, 3, 4, 5, 6, 7], value: [23, 56, 78, 67, 189, 56, 90] },
            ],
        }
    },
    watch: {},
    created() {
        this.baseArea = this.baseArea.filter(item => {
            return item.label == '内蒙古自治区'
        })
    },
    mounted() {
        this.Btn(0)
        this.setBarData(this.breedData)
        this.setLineData(this.day, 'lineChart')
        this.lineBarChart(this.lineBarData)
    },
    // 销毁定时器
    destroyed() {

    },
    // 日期过滤
    filters: {
    },
    methods: {
        // 返回上一层
        goBack() {
            this.$router.go(-1)
        },
        changeKindList() {

        },
        videoShow() {

        },
        archives() {
            if (this.btnStatus == 0) {
                this.$refs.netWorkModel.showModel()
            }
        },
        // 翻页
        btnClick(val) {
            if (val === 'left') {
                if (this.pageNum > 1 && this.total > 10) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    if (this.pageNum <= 0) {
                        this.pageNum = 1
                        this.statusRight = 'right'
                        this.status = ''
                        return
                    }
                    this.pageNum--
                    this.pageNum == 1 ? this.status = '' : this.status = 'left'
                    this.flag = false
                    this.getLivestockList()
                } else {
                    this.status = ''
                }
            }
            if (val === 'right') {
                if (this.flag) return
                if (this.pageNum >= 0 && this.total > 10) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    if ((this.pageNum * 10) >= this.total) {
                        this.pageNum = this.pageNum - 1
                        this.status = 'left'
                        this.statusRight = ''
                        this.flag = true
                        return
                    }
                    this.pageNum++
                    this.pageNum == Math.ceil((this.total / 10)) ? this.statusRight = '' : this.statusRight = 'right'
                    this.getLivestockList()
                } else {
                    this.statusRight = ''
                }
            }
        },
        selectLive(command) {
            this.command = command
        },
        focus() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = ''
        },
        blur() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = '输入耳标编号搜索活畜'
        },
        // 跳转养殖户详情
        details() {
            // console.log(this.breeList[val.rowIndex]);
            // window.localStorage.setItem('MYINFO', JSON.stringify(this.breeList[val.rowIndex]))
            // this.$router.push({ name: 'details' })
        },
        // 搜索
        getList() {

        },
        // 重置
        reset() {
            this.address = [];
            this.userType = '';
            this.userName = '';
            this.status = ''
        },
        // 活畜信息分布
        cattleStatusBtn(val) {
            this.cattleStatus = val
            // this.setBarData(this[val])
        },
        // 产犊数量
        calvingBtn(val) {
            this.calvingStatus = val
        },
        // 发情配种
        breedBtn(val) {
            this.breedStatus = val
        },
        // 产犊趋势图
        serviceStatusBtn(val) {
            this.serviceStatus = val
            // this.setLineData(this[val], 'lineChart')
        },
        Btn(val) {
            this.btnStatus = val
            if (val == 0) {
                this.config = {
                    header: ['耳标编码', '活畜类别', '活畜品种', '月龄(月)', '操作'],
                    data: [
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],
                        [10000, '类别', '羊毛', 4, 6],

                    ],
                    align: ['left', 'left', 'left', 'center', 'center'],
                    // columnWidth: [200, 250, 200, 200, 150],
                    headerHeight: 40,
                    rowNum: 7,
                    waitTime: 2000
                }
            } else {
                this.config = {
                    header: ['耳标编码', '活畜类别', '活畜品种', '盘点结果', '盘点时间', '盘点说明'],
                    data: [
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">正常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">异常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">正常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">异常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">异常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">正常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">异常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">正常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">异常</span>`, 6, 'dssdf'],
                        [10000, '类别', '羊毛', `<span style="color: #FFFFFF;" class="setColor">异常</span>`, 6, 'dssdf'],
                    ],
                    align: ['left', 'left', 'left', 'left', 'left', 'left',],
                    // columnWidth: [200, 250, 200, 200, 150],
                    headerHeight: 40,
                    rowNum: 7,
                    waitTime: 2000
                }
                this.$nextTick(() => {
                    setInterval(() => {
                        var setColor = document.querySelectorAll('.table .dv-scroll-board .rows .setColor')
                        setColor.forEach((item) => {
                            if (item.innerHTML == '异常') {
                                item.style.color = '#FFF200'
                            }
                        })
                    }, 0)
                })
            }
        },
        // 淘汰/产犊数量折柱趋势图
        lineBarChart(data) {
            var myChart = this.$echarts.init(document.getElementById('lineBarChart'));
            var option = {
                legend: {
                    top: '3%',
                    // // left: '3%',
                    right: '15%',
                    // bottom: '60%',
                    show: false,
                    itemWidth: 12,
                    itemHeight: 12,
                    data: [
                        {
                            name: data[0].title,
                            textStyle: {
                                color: '#0EDAE2'
                            },
                        },
                        {
                            name: data[1].title,
                            textStyle: {
                                color: '#00ACFC'
                            },
                            // bottom: 10
                        }
                    ]
                },
                grid: {
                    top: '20%',
                    bottom: '0%',
                    // height: "48%",
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    show: true,
                    axisLine: {
                        lineStyle: {
                            color: '#19ECFF',//x轴线条颜色宽度
                            width: 1
                        }
                    },
                    axisLabel: { color: '#FFFFFF' },//x轴刻度文字颜色
                    scale: false,
                    axisTick: { show: false },
                    data: data[0].label
                },
                yAxis: [{
                    type: 'value',
                    name: data[0].title,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF'
                        }
                    },
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    offset: 10,
                    axisTick: { show: false },
                },
                {
                    type: 'value',
                    show: true,
                    name: data[1].title,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#0c1d55'
                        }
                    },
                    offset: 10,
                    // splitNumber: 4,
                    axisTick: { show: false },
                }
                ],
                series: [
                    {
                        name: data[1].title,
                        data: data[1].value,
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: 5,
                        yAxisIndex: 1,
                        itemStyle: {
                            color: '#5D2CFE'
                        }
                    },
                    {
                        name: data[0].title,
                        data: data[0].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 15,
                        // itemStyle: {
                        //     opacity: 0.8,
                        //     color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //         {
                        //             offset: 1,
                        //             color: '#0BE5E1',
                        //         },
                        //         {
                        //             offset: 0,
                        //             color: '#06FDF5',
                        //         },
                        //     ]),
                        // },
                        backgroundStyle: {
                            // color: 'rgba(44, 118, 254, 0.2)'
                            color: '#00E0DB'
                        },
                        itemStyle: {
                            opacity: 1,
                            // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            //     {
                            //         offset: 1,
                            //         color: "#297DFC",
                            //     },
                            //     {
                            //         offset: 0,
                            //         color: "#06FDF5",
                            //     },
                            // ]),
                            color: "rgba(25,236,255,1.000)"
                        },

                        // tooltip: {
                        //     trigger: 'item'
                        // },
                    }
                ],
                tooltip: {//鼠标悬浮提示数据
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    // formatter: function (params) {
                    //     // console.log(params, 2)
                    //     // return `<p>
                    //     //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                    //     //     }： ${params.data.account || 0} </span>

                    //     //       </p>`;
                    //     return `
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                    //         }</p><br/>
                    //     <p>
                    //       <span style="font-size: 14px; font-weight: normal;">监管笔数(笔)： ${ 0} </span>
                    //     </p><br/> 
                    //      <p>
                    //       <span style="font-size: 14px; font-weight: normal;">监管金额(万)： ${ 0} </span>
                    //      </p>`;
                    //     // return params.name
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                }
            };
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        setLineData(data, dom) {
            const colors = ['#19ECFF', '#2C41FE', '#40FF00'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "0%",
                    right: "6%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    // formatter: function (params) {
                    //     // console.log(params, 'params');
                    //     // return `<p>
                    //     //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                    //     //     }： ${params.data.account || 0} </span>

                    //     //       </p>`;
                    //     return `
                    //     <p style="font-size: 14px; font-weight: normal;">
                    //         }</p><br/>
                    //      <p>
                    //     <p style="font-size: 14px; font-weight: normal;">
                    //         }</p><br/>
                    //      <p style="font-size: 14px; font-weight: normal;"></p><br/>
                    //      <p style="font-size: 14px; font-weight: normal;"></p>
                    //      `;
                    //     // return params.name
                    // },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '20%',
                    left: '11%',
                    right: '6%',
                    bottom: '0%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#19ECFF',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '重量(kg)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 45, 0, 0],
                    },
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 存栏柱状图
        setBarData(data) {
            var chart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    // formatter: function (params) {
                    //     // console.log(params,'params');
                    //     if (params[0].name.indexOf("牛") != -1) {
                    //         return `
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                    //             }</p><br/>
                    //      <p>
                    //       <span style="font-size: 14px; font-weight: normal;">存栏数量： ${params[0].value || 0} 头 </span>
                    //      </p>`;
                    //     } else {
                    //         return `
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                    //             }</p><br/>
                    //      <p>
                    //       <span style="font-size: 14px; font-weight: normal;">存栏数量： ${params[0].value || 0} 只 </span>
                    //      </p>`;
                    //     }
                    // },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '20%',
                    // 20
                    left: '11%',
                    right: '4%',
                    bottom: '0%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        // rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: 'rgba(25,236,255,1.000)',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data.label,
                },
                yAxis: {
                    // name: '数量(头)',
                    name: '数量(头)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 45, 0, 0],
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00E0DB'
                    },
                    itemStyle: {
                        opacity: 1,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "#1981FF"
                    },
                    data: data.value,
                },
            }
            chart.clear();
            chart.setOption(option)
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    // position: relative;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // background-color: #030E27;
    background: #05182a;
    background-size: 100% 100%;

    .head {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.35rem;
        background: url('../../assets/yq/header.png');
        background-size: 100% 100%;
        font-size: 0.55rem;
        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
        font-weight: 700;
        color: #19ECFF;
        letter-spacing: 5px;

        .gobcak {
            position: absolute;
            bottom: 0;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        display: flex;
        width: 100%;
        // height: 12.25rem;
        margin: .25rem auto 0;
        padding: 0 .26rem .25rem;

        .left {
            width: 7rem;
            height: 11.65rem;
            background: url(../../assets/yq/left-bg.png);
            background-size: 100% 100%;

            .top {
                margin-left: .36rem;
                margin-top: .46rem;

                h1 {
                    font-size: 0.3rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: 700;
                    color: #FFFFFF;
                }

                .phone-type {
                    display: flex;
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                    font-weight: 350;
                    color: #FFFFFF;
                    margin-top: .35rem;

                    .type {
                        margin-left: 1.68rem;
                    }
                }

                .photo-box {
                    display: flex;
                    margin: .31rem 0;

                    img {
                        width: .63rem;
                        height: .63rem;
                    }

                    .num-box {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;

                        .num {
                            font-size: 0.25rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: 700;
                            color: #FFFFFF;
                        }

                        .txt {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                            font-weight: 350;
                            color: #FFFFFF;
                            padding-top: .1rem;
                        }
                    }
                }

                .quan {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-right: .25rem;
                    margin-top: .18rem;

                    .el-dropdown {
                        min-width: 1.63rem;
                        height: 0.38rem;
                        line-height: .33rem;
                        background: rgba(0, 223, 218, 0.0588);
                        border-radius: 0rem 0rem 0rem 0rem;
                        opacity: 1;
                        border: 0.01rem solid rgba(0, 223, 218, 0.4);
                        // margin-right: .25rem;
                        cursor: pointer;
                    }

                    .el-dropdown-link {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background: transparent;
                        // padding: 0.05rem 0.19rem;
                        font-size: 0.15rem;
                        font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                        font-weight: 400;
                        color: #00E0DB;

                        i {
                            margin-right: .1rem;
                        }
                    }

                    .screenFull {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        img {
                            display: block;
                            width: .25rem;
                            height: .25rem;
                        }

                        span {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #19ECFF;
                            margin-left: .09rem;
                        }
                    }
                }

                .device_main {
                    display: flex;
                    align-items: center;
                    margin-top: .23rem;
                    position: relative;

                    .video_box {
                        position: relative;
                        // width: 7.63rem;
                        width: 6.37rem;
                        height: 3.63rem;
                        padding: .2rem;
                        border: 0.01rem solid rgba(0, 224, 219, 0.08);
                        margin-right: .25rem;

                        &::after {
                            position: absolute;
                            left: 0;
                            top: 0;
                            content: "";
                            width: .15rem;
                            height: .11rem;
                            border-left: 1px solid #00E0DB;
                            border-top: 1px solid #00E0DB;
                        }

                        &::before {
                            position: absolute;
                            right: 0;
                            top: 0;
                            content: "";
                            width: .15rem;
                            height: .11rem;
                            border-right: 1px solid #00E0DB;
                            border-top: 1px solid #00E0DB;
                        }

                        .top_box {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: .2rem;

                            &::after {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                content: "";
                                width: .15rem;
                                height: .11rem;
                                border-left: 1px solid #00E0DB;
                                border-bottom: 1px solid #00E0DB;
                            }

                            &::before {
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                content: "";
                                width: .15rem;
                                height: .11rem;
                                border-right: 1px solid #00E0DB;
                                border-bottom: 1px solid #00E0DB;
                            }
                        }

                        .device_box {
                            // width: 7.23rem;
                            width: 6rem;
                            height: 3.2rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }

            }

            .center {
                padding: 0 .25rem;

                .hot {
                    margin-top: .33rem;

                    .hot-box {
                        width: 6.49rem;
                        height: 0.74rem;
                        background: rgba(25, 236, 255, 0.05);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: .13rem;

                        .l-box {
                            display: flex;
                            align-items: center;

                            img {
                                display: inline-block;
                                width: .3rem;
                                height: .3rem;
                                margin-left: .23rem;
                            }

                            .text {
                                display: flex;
                                flex-direction: column;
                                // align-items: center;
                                justify-content: center;
                                margin-left: .25rem;
                                font-size: 0.15rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;

                                span:nth-child(1) {
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }

                                span:nth-child(2) {
                                    font-weight: 500;
                                    color: #7B8A8A;
                                    padding-top: .1rem;
                                }
                            }
                        }

                        .look {
                            // width: 0.38rem;
                            height: 0.23rem;
                            background: rgba(25, 236, 255, .3);
                            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                            font-size: 0.13rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #19ECFF;
                            line-height: 0.09rem;
                            text-align: center;
                            padding: 0.06rem;
                            margin-right: .25rem;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .right {
            width: 16.25rem;
            height: 11.65rem;
            background: url(../../assets/yq/right-bg.png);
            background-size: 100% 100%;
            margin-left: .25rem;

            .num {
                display: flex;
            }

            .number {
                display: flex;
                align-items: center;
                margin-left: .38rem;
                margin-top: .43rem;

                .hc-num {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                }

                ul {
                    display: flex;

                    li {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-left: .19rem;
                        width: 0.5rem;
                        height: 0.5rem;
                        background: rgba(0, 224, 219, 0.05);
                        box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
                        border-radius: 0rem 0rem 0rem 0rem;
                        opacity: 1;
                        border: 0.01rem solid rgba(0, 224, 219, 0.1);
                        font-size: 0.38rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: 700;
                        color: #FFF200;
                    }
                }
            }

            .r-c {
                display: flex;

                .line-bar {
                    width: 6rem;

                    #lineBarChart {
                        width: 100%;
                        height: 2rem;
                        margin-top: .25rem;
                    }
                }

                .bar {
                    #barChart {
                        width: 100%;
                        height: 2rem;
                        margin-top: .25rem;
                    }
                }

                .line {
                    #lineChart {
                        width: 100%;
                        height: 2rem;
                        margin-top: .25rem;
                    }
                }

                .commom {
                    flex: 1;
                }
            }

            .cut {
                display: flex;
                margin-top: .38rem;
                margin-left: .31rem;

                span {
                    display: inline-block;
                    min-width: 0.88rem;
                    // height: 0.05rem;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #7B8A8A;
                    line-height: .5rem;
                    cursor: pointer;
                }

                span:nth-child(2) {
                    margin-left: .8rem;
                }
            }

            .table {
                // height: 6.75rem;
                margin: .26rem .31rem 0 .31rem;

                .search {
                    height: .38rem;
                    display: flex;
                    align-items: center;
                    position: relative;

                    .search_input.el-input {
                        width: 2.25rem !important;
                    }

                    .btn_1 {
                        width: 1.1rem;
                        height: 0.38rem;
                        font-size: 0.15rem;
                        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                        font-weight: 400;
                        text-align: center;
                        line-height: .38rem;
                        cursor: pointer;
                    }

                    .btn {
                        background: #00E0DB;
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        color: #032929;
                        margin-left: 1.12rem;
                    }

                    .reset_btn {
                        background: #013D4E;
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        color: #00E0DB;
                        margin-left: 0.13rem;
                    }

                    .total {
                        display: block;
                        display: flex;
                        align-items: center;
                        min-width: 1rem;
                        height: 0.18rem;
                        font-size: 0.13rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #D8DFFE;
                        line-height: 0.18rem;
                        margin-left: .2rem;

                        span {
                            color: #FCD827;
                            font-size: .2rem;
                            padding: 0 .1rem;
                        }
                    }

                    .left_ {
                        margin-left: 1rem;
                        margin-right: .14rem;
                    }

                    .l_f {
                        width: 0.38rem;
                        height: 0.38rem;
                        background: rgba(255, 255, 255, 0.05);
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        text-align: center;
                        line-height: .38rem;
                        cursor: pointer;
                        color: #7B8A8A;

                        span {
                            width: 0.1rem;
                            height: 0.17rem;
                            font-weight: 700;
                        }
                    }
                }
            }
        }

        .server {
            display: flex;
            // justify-content: space-between;
            align-items: center;

            .card {
                width: 0.18rem;
                height: 0.44rem;
                display: block;
                background: #19ECFF;
            }

            .text {
                font-size: 0.25rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: 700;
                color: #19ECFF;
                margin-left: .19rem;
            }
        }

        .server-b {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: .3rem;

            .card-1-b {
                // width: 1.35rem;
                // height: 0.23rem;
                line-height: 0.23rem;
                font-size: 0.23rem;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #19ECFF;
                padding-left: .37rem;
            }

            .date-b {
                color: #7B8A8A;
                padding-right: 0.26rem;

                span {
                    display: inline-block;
                    width: 0.44rem;
                    padding: .05rem;
                    font-size: 0.13rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    background: rgba(255, 255, 255, 0.05);
                    // opacity: .5;
                    border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                    cursor: pointer;
                    text-align: center;
                }

                span {
                    margin-left: .13rem;
                }

                span:nth-child(1) {
                    margin-left: 0rem;

                }
            }
        }

        .active {
            background: rgba(7, 71, 85, 1.000) !important;
            color: #00E0DB;
        }

        .activeStatus {
            font-size: 0.25rem !important;
            font-weight: 700 !important;
            color: #19ECFF !important;
            border-bottom: .05rem solid #19ECFF;
        }

        .activeBtn {
            background: rgba(7, 71, 85, 1.000) !important;
            color: #00E0DB !important;
        }
    }
}
</style>
<style lang="scss">
.partner {
    .partner .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }
    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: 0.01rem solid rgba(25, 236, 255, 0.4);
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .el-select>.el-input {
        // width: 2.2rem;
    }

    .search_input>.el-input__inner {
        // padding: 0 0 0 .4rem;
        width: 3.25rem !important;
    }

    .header {
        background: rgba(0, 224, 219, 0.08) !important;
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #19ECFF;
    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        // height: 3.5rem!important;
        padding: .15rem 0 .3rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                // margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        // color: #FFC300;
    }

    // 排名轮播
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

    .dv-water-pond-level canvas {
        border: 1px solid #21EEE9;
        margin-left: .09rem;
        margin-top: .09rem;
    }

    .dv-water-pond-level text {
        font-size: 0.23rem !important;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
        font-weight: 500 !important;
        color: #010E26 !important;
        opacity: 0 !important;

    }
}

@media only screen and (max-width: 1900px) {
    .header {
        width: 100%;
    }

    .header-item {
        font-size: 8px !important;
    }

    .header-item:last-child {
        // width: 2.5rem !important;
        // background: #013346;
        // opacity: 1;
    }

    .dv-digital-flop,
    .active-ring-name {
        font-size: 12px !important;
    }
}</style>